var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('degree-detail',{attrs:{"user":"admin"}})}
var staticRenderFns = []

export { render, staticRenderFns }